import styled from "styled-components";

export const Container = styled.div`
  margin-top: 20px;
  .btn {
    border: none;
    outline: none;
    border-radius: 10em;
    padding: ${(props) => (props.padding ? "0.8em 1em" : "1.2em 3em")};
    background: linear-gradient(to right, #f94e3f, #fe7745);
    color: #fff;
  }

  .btn-icon {
    color: #fff;
    font-size: 1.2em;
  }
`;
